import { render, staticRenderFns } from "./ChartsPie.vue?vue&type=template&id=6ebcd440&"
import script from "./ChartsPie.vue?vue&type=script&lang=js&"
export * from "./ChartsPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports